import { ButtonRadioGroupField, Popup, PopupArrow } from '@cian/components';
import { Outside } from '@cian/ui-kit';
import { mergeStyles } from '@cian/utils';
import { Checkbox } from '../Checkbox';
import * as React from 'react';

import { FDealType, FOfferType } from '../../utils/category';
import { getOfferTypeLabel } from '../../utils/offerType';
import { normalizeOfferType, getOfferTypeList } from './helpers';
import * as stylesCommon from '../FiltersCommon/FiltersCommon.css';
import * as styles from './FilterOfferType.css';
import { CoworkingHelper } from '../CoworkingtHelper';

export interface IFilterOfferTypeProps {
  canShowPopupAutoChangeToSuburban: boolean;
  dealType: FDealType;
  offerType: FOfferType;
  hidePopupAutoChangeToSuburban(): void;
  onSelect(offerType: FOfferType): void;
}

export interface IFilterOfferTypeState {
  active: boolean;
}

export class FilterOfferType extends React.Component<IFilterOfferTypeProps, IFilterOfferTypeState> {
  public constructor(props: IFilterOfferTypeProps) {
    super(props);

    this.state = {
      active: false,
    };
  }

  public render(): React.ReactNode {
    const { dealType, offerType, canShowPopupAutoChangeToSuburban } = this.props;
    const { active } = this.state;

    const offerTypes = getOfferTypeList(dealType, offerType);
    const offerTypeLabel = getOfferTypeLabel(dealType, offerType);

    return (
      <>
        <Outside onOutside={this.handleOutsideClick}>
          <div {...mergeStyles(stylesCommon['container'], styles['container'])} data-mark="FilterOfferType">
            <button
              {...mergeStyles(stylesCommon['button'], active ? stylesCommon['button--active'] : undefined)}
              title={offerTypeLabel || undefined}
              onClick={this.handleButtonClick}
            >
              {offerTypeLabel || 'Недвижимость'}
            </button>
            {active && (
              <div className={styles['dropdown']}>
                {dealType !== FDealType.RentDaily && (
                  <ButtonRadioGroupField
                    containerStyle={styles['radio-group']}
                    buttonStyle={styles['radio-button']}
                    activeButtonStyle={styles['radio-button--active']}
                    value={String(normalizeOfferType(offerType))}
                    values={[
                      { value: String(FOfferType.Residential), label: 'Жилая' },
                      {
                        value: String(FOfferType.Commercial),
                        label: 'Коммерческая',
                      },
                    ]}
                    onValueChange={this.handleRadioButtonClick}
                  />
                )}
                <ul className={styles['list']}>
                  {offerTypes.map((part, index) => (
                    <li key={`part_${index}`}>
                      <ul className={styles['list-inner']}>
                        {part.map(item => (
                          <li key={`item_${item.label}`}>
                            <Checkbox
                              label={item.label}
                              value={item.value}
                              checked={(offerType & item.value) !== 0}
                              onChange={this.handleChangeOfferType}
                            />
                          </li>
                        ))}
                      </ul>
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        </Outside>
        {!active && canShowPopupAutoChangeToSuburban && (
          <Outside onOutside={this.props.hidePopupAutoChangeToSuburban}>
            <div>
              <Popup arrow={PopupArrow.NONE} containerStyle={styles['info-popup']}>
                {'Тип недвижимости изменен, потому что\nвы выбрали коттеджный поселок'}
              </Popup>
            </div>
          </Outside>
        )}
        {!active && <CoworkingHelper className={styles['coworking-notification']} />}
      </>
    );
  }

  private readonly handleButtonClick = (): void => {
    this.setState(state => ({
      active: !state.active,
    }));
  };

  private readonly handleOutsideClick = (): void => {
    this.setState({
      active: false,
    });
  };

  /* istanbul ignore next */
  private readonly handleRadioButtonClick = (newOfferTypeString: string): void => {
    const { offerType: oldOfferType } = this.props;

    const newOfferType: FOfferType = Number(newOfferTypeString);

    if (normalizeOfferType(oldOfferType) !== normalizeOfferType(newOfferType)) {
      this.handleOfferTypeSelect(newOfferType === FOfferType.Residential ? FOfferType.Flat : FOfferType.Office);
    }
  };

  /* istanbul ignore next */
  private readonly handleChangeOfferType = (e: React.ChangeEvent<HTMLInputElement>): void => {
    const offerType: FOfferType = Number(e.currentTarget.value);
    this.handleOfferTypeSelect(offerType);
  };

  /* istanbul ignore next */
  private readonly handleOfferTypeSelect = (offerType: FOfferType): void => {
    if (offerType === this.props.offerType) {
      return;
    }

    if (
      [FOfferType.FlatOld, FOfferType.FlatNew].includes(offerType) &&
      (this.props.offerType & FOfferType.Flat) !== 0
    ) {
      if (this.props.offerType === FOfferType.Flat) {
        this.props.onSelect(offerType === FOfferType.FlatOld ? FOfferType.FlatNew : FOfferType.FlatOld);
      } else {
        this.props.onSelect(FOfferType.Flat);
      }
    } else {
      this.props.onSelect(offerType);
    }
  };
}
